module.exports = __webpack_public_path__ + "static/assets/3bf9cfad9ca61a32d16fdd5c4aaa93d0.svg";